// components
import { SettingsValueProps } from '@mymeeinc/shared-web/components/settings/type';
import { Projects } from '@mymeeinc/types/config';
import { UserTypes } from '@mymeeinc/types/user';

// SETTINGS
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const defaultSettings: SettingsValueProps = {
  projectName: 'Mymee Admin Panel',
  environmentPrefix: import.meta.env.MODE !== 'production' ? '[' + import.meta.env.MODE + '] ' : '',
  project: Projects.ADMIN,
  appUserType: UserTypes.ADMIN,
  themeMode: 'light',
  themeDirection: 'ltr',
  themeContrast: 'default',
  themeLayout: 'horizontal',
  themeColorPresets: 'purple', // 'default' | 'purple' | 'cyan' | 'blue' | 'orange' | 'red';
  themeStretch: false,
};
